module.exports = __webpack_public_path__ + "img/分享店铺.9688024d.svg";